import { useState } from "react";
import { useFormik } from "formik";
import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useAuthContext } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import compInfos from "./login.json";
import { useLangContext } from "../../context/langContext";
import { object, string } from "yup";
import MuiTextField from "../../components/common/text-field/MuiTextField";
import { TokenRequest } from "../../services/Endpoints/auth";
import { usePublicAxiosInstance } from "../../hooks/axiosInstance";
import errorResolver from "../../utils/error-resolver";
import { useNotificationContext } from "../../context/notificationContext";
export default function LoginForm() {
  const [waiting, setWaiting] = useState(false);
  const publicInstance = usePublicAxiosInstance();
  const { setNotification } = useNotificationContext();

  const { login } = useAuthContext();
  const navigate = useNavigate();
  const { lang } = useLangContext();

  const infos = compInfos[lang];
  const mobileError = infos.inputs[0].errors;
  const passwordError = infos.inputs[1].errors;
  const loginSchema = object({
    mobile: string()
      .min(11, mobileError.min)
      .required(mobileError.required)
      .max(12),
    password: string()
      .min(8, passwordError.min)
      .required(passwordError.required),
  });

  const formik = useFormik({
    initialValues: {
      mobile: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      setWaiting(true);
      const tokenRequest = new TokenRequest(publicInstance);
      try {
        const { mobile, password } = values;
        const resp = await tokenRequest.send({ mobile, password });
        const token = resp.data.credential.token;
        login(token);
        navigate("/");
      } catch (error: any) {
        errorResolver({ error, setNotification });
      } finally {
        setWaiting(false);
      }
    },
    enableReinitialize: true,
  });

  return (
    <Stack
      maxWidth="100%"
      width={{ xs: "100%", md: "90%" }}
      gap="20.31px"
      mx="10px"
      px={{ xs: "8px", md: "0" }}
      component="form"
      onSubmit={formik.handleSubmit}
    >
      {infos.inputs.map(
        ({ Example, errors, label, placeholder, name, type }) => (
          <MuiTextField
            key={name}
            width="100%"
            label={label}
            placeholder={placeholder}
            name={name}
            type={type}
            inputMode={name == "mobile" ? "numeric" : "text"}
            value={formik.values[name as "mobile"]}
            handleChange={formik.handleChange}
            Example={Example}
            error={
              formik.touched[name as "mobile"] &&
              Boolean(formik.errors[name as "mobile"]) &&
              formik.errors[name as "mobile"]
            }
          />
        )
      )}

      <LoadingButton
        sx={{ mt: "10px" }}
        variant="contained"
        type="submit"
        loading={waiting}
      >
        {infos.buttonText}
      </LoadingButton>
    </Stack>
  );
}
//
